import Api from "./baseApi";

const controllerPath = "/files";

const DefaultApi = {
  post(data) {
    return Api.post(`${controllerPath}/upload`, data);
  },
  get(id) {
    return Api.get(`/default/file`, {params: {id: id}});
  },
  download(id) {
    return Api.get(`${controllerPath}/${id}/download`, { responseType: 'blob' });
  }
};

export default DefaultApi;
